import type React from 'react';
import { Table } from 'components';
import type { SerializedCustomerWithLicensesStats } from '@enmon/commons/lib/enmon';
import { Link } from 'react-router-dom';
import type { TablePaginationConfig } from 'antd';

interface ResellersTableProps {
  pagination: TablePaginationConfig;
  resellers?: SerializedCustomerWithLicensesStats[];
  isLoading: boolean;
}

export const ResellersTable: React.VFC<ResellersTableProps> = ({ resellers = [], pagination, isLoading }) => (
  <Table
    columns={[
      {
        title: 'Customer',
        key: 'customer',
        render: (_, { _id, name }) => <Link to={`/portfolio/customers/details/${_id}`}>{name}</Link>,
      },
      {
        title: 'Country',
        key: 'country',
        dataIndex: ['country'],
      },
      {
        title: 'Customers',
        key: 'customers',
        dataIndex: ['stats', 'customers', 'count'],
      },
      {
        title: 'Establishments',
        key: 'establishments',
        dataIndex: ['stats', 'opex', 'establishments', 'count'],
      },
      {
        title: 'Meters online',
        key: 'meters_online',
        dataIndex: ['stats', 'opex', 'metersOnline', 'count'],
      },
      {
        title: 'Meters offline',
        key: 'meters_offline',
        dataIndex: ['stats', 'opex', 'metersOffline', 'count'],
      },
    ]}
    dataSource={resellers}
    loading={isLoading}
    pagination={pagination}
    rowKey={row => row._id}
    scroll={{ x: true }}
  />
);
